
<template>
    <div class="module-view-container">
        <ThatsTable title="Tier Benefits" ref="table" :endpoint="endpoint" @openModal="openWindow" @deleteYes="DispatchDelete" @openUpdateModal="OpenUpdateModal" :columns="columns" :importBtn="false" @import="importProduct">

             <template #custom-culumns="{columns, getValue, handleClick}">
                        <template v-for="col in columns">
                            <el-table-column v-bind:key="col.field" :sortable="col.sortable" :width="col.width" :prop="col.field" :label="col.label" :align="col.align">
                                <template slot-scope="scope">
                                    <template v-if="col.hasOwnProperty('clickable') && col.clickable === true ">
                                        <a href="javascript:void(0)" @click="handleClick(scope.$index, scope.row)" v-html="`${scope.row[col.field]}`"></a>
                                    </template>
                                    <template v-else>
                                        {{getValue(scope,col.field)}}
                                        <div v-html="(scope.row[col.field] === 'null' || scope.row[col.field] === null ? '-' : scope.row[col.field])"></div>

                                    </template>
                                </template>

                            </el-table-column>
                        </template>

<!--                        <el-table-column label="Tier">-->
<!--                            <template slot-scope="scope">-->
<!--                                {{scope.row.tiers.name}}-->
<!--&lt;!&ndash;                               <a href="javascript:void(0)" @click="viewSignature(scope.row)">View</a>&ndash;&gt;-->
<!--                            </template>-->
<!--                        </el-table-column>-->
             </template>
        </ThatsTable>
        <TierBeneficiaryForm ref="dialogForm" @success="refreshTable" @delete="formDelete"></TierBeneficiaryForm>
        <TableError :data="errorData" ref="tableError" :group="2"></TableError>



    </div>
</template>
<script>
import { mapGetters, mapMutations,mapActions } from 'vuex';
import {mdbTabs, mdbBtn} from 'mdbvue'
import TierBeneficiaryForm from './TierBeneficiaryForm'
import ThatsTable from '../../components/thats/Table'
import TableError from '../../components/filemanager/TableError'
export default {
    data(){
        return {
            endpoint : 'loyalty-program/tier-beneficiary',
            importData : {},
            errorData : {},
            importLoading : false,
            group1 : ["name"],
            group2 : ['email', 'role',],
            galleryData : [],
            active : 0,
            signature : '',
        }
    },
    components: {
        TierBeneficiaryForm,
        ThatsTable,
        TableError,
        mdbTabs,
        mdbBtn

    },

    methods: {
        ...mapActions('TableModule',[
            'resetData',
        ]),
        ...mapActions('TierBeneficiaryModule',[ 'DeleteRecord','saveImport' ]),
        ...mapMutations('TierBeneficiaryModule',[ 'SetFormRecord', 'SetFormStatusUpdate','SetPage']),
        checkGroup1(column){
           return this.group1.includes(column)
        },
        checkGroup2(column){
           return this.group2.includes(column)
        },
        viewImage(index,row){
            this.galleryData = [];
            if(row.images.length){
                row.images.forEach(element => {
                    this.galleryData.push({
                        img: true,
                        src: element.large,
                        alt: element.name,
                        caption: {
                        title: element.name
                        }
                    })
                });

                this.$refs.galleryWindow.openDialog()
            }

        },

        viewEtaHandler(index,eta){
            this.etaData = []
            this.etaData = eta;
            this.$refs.etaWindow.openDialog();
        },
        viewSoldToHandler(index,eta){
            this.etaData = []
            this.etaData = eta;
            this.$refs.etaWindow.openDialog();
        },
        formDelete(record){
            const items = [];
            items.push(record.row);
            this.DispatchDelete(items);
        },
        DispatchDelete(items){
            var self = this;
            self.DeleteRecord(items).then((response) => {
                self.$ThatsNotify.success({
                    message : `(${response.deleted}) record was successfully deleted.`
                })
               self.refreshTable();
            })
            this.closeWindow()
        },
        OpenUpdateModal(obj){
            this.SetFormStatusUpdate()
            this.SetFormRecord(obj)
            this.openWindow()
        },
        openWindow(){
            this.$refs.dialogForm.openDialog()
        },
        closeWindow(){
            this.$refs.dialogForm.closeDialog()
        },
        refreshTable(){
            this.$refs.table.refreshTable()
        },
        importProduct(){
           this.$refs.uploadForm.openDialog()
        },
        fileData(v){
            this.importData = v
            // console.log(v)

           this.$refs.tableImport.openDialog()
        },

        importNow(v){
            if(!this.importLoading){
                this.importLoading = true
                this.saveImport({ row : v}).then((response) => {

                    this.importLoading = false,
                    this.$ThatsNotify.success({
                        message : response.message,
                        timeOut : 10000
                    })
                    this.$refs.tableImport.closeDialog();
                    this.$refs.table.refreshTable()

                    if(response.error.rows.length > 0){
                        this.errorData = response.error
                        this.$refs.tableError.openDialog()
                    }

                    return;

                }).catch((error) => {
                    this.importLoading = false,
                    this.$ThatsNotify.warning({
                        message : `Please check file might some column of record has invalid value.`,
                        timeOut : 10000
                    })
                    this.$refs.table.refreshTable()
                })
            }

        },

        getActiveTabIndex(index){

            const tabs = [1,2,3,0,4,5]
            this.endpoint = 'wallpaper/data?status='+tabs[index];
            this.SetPage(1)
            this.resetData('wallpaper/data?status='+tabs[index]);

        },



        selectText(element) {
            var range;
            if (document.selection) {
                // IE
                range = document.body.createTextRange();
                range.moveToElementText(element);
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(element);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
            },
        openBulkReset(){
            this.$refs.bulkReset.openDialog();
        }

    },
    computed: {
        ...mapGetters('TierBeneficiaryModule',[ 'data', 'page', 'total', 'page', 'length', 'columns', 'Loading', ])
    },
}
</script>
<style scoped>
.container {
    position: relative;
    min-height: 340px;
  }
  .placement {
    position: absolute;
    right: 0;
  }
</style>
